import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/student_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  name_cont: {
    model_name: 'Student',
    column_type: 'string',
    column_name: 'name',
  },
  phone_cont: {
    model_name: 'Student',
    column_type: 'string',
    column_name: 'phone',
  },
  user_id_eq: {
    column_type: 'belongs_to',
    column_name: 'user',
    extra: {
      model_name: 'User',
    },
    model_name: 'Student',
  },
  user: {
    column_type: 'belongs_to',
    column_name: 'user',
    extra: {
      model_name: 'User',
    },
    model_name: 'Student',
  },
  city_cont: {
    model_name: 'Student',
    column_type: 'string',
    column_name: 'city',
  },
  gender_eq: {
    column_type: 'enum',
    extra: {
      model_name: 'Student',
      options: ['unknown', 'male', 'female'],
    },
    model_name: 'Student',
    column_name: 'gender',
  },
  nps_source_cont: {
    model_name: 'Student',
    column_type: 'string',
    column_name: 'npsSource',
  },
  occupation_cont: {
    model_name: 'Student',
    column_type: 'string',
    column_name: 'occupation',
  },
  student_eq: {
    column_type: 'boolean',
    model_name: 'Student',
    column_name: 'student',
  },
  holder_eq: {
    column_type: 'boolean',
    model_name: 'Student',
    column_name: 'holder',
  },
  bridge_eq: {
    column_type: 'boolean',
    model_name: 'Student',
    column_name: 'bridge',
  },
  partner_eq: {
    column_type: 'boolean',
    model_name: 'Student',
    column_name: 'partner',
  },
  potential_eq: {
    column_type: 'boolean',
    model_name: 'Student',
    column_name: 'potential',
  },
  remark_cont: {
    model_name: 'Student',
    column_type: 'string',
    column_name: 'remark',
  },
  youth_camp_course_numbers_cont: {
    model_name: 'Student',
    column_type: 'string',
    column_name: 'youthCampCourseNumbers',
  },
  book_club_course_numbers_cont: {
    model_name: 'Student',
    column_type: 'string',
    column_name: 'bookClubCourseNumbers',
  },
  nps_value_cont: {
    model_name: 'Student',
    column_type: 'string',
    column_name: 'npsValue',
  },
  nps_list_cont: {
    model_name: 'Student',
    column_type: 'string',
    column_name: 'npsList',
  },
  course_stickiness_cont: {
    model_name: 'Student',
    column_type: 'string',
    column_name: 'courseStickiness',
  },
  height_gteq: {
    model_name: 'Student',
    column_type: 'string',
    column_name: 'height',
  },
  height_lteq: {
    model_name: 'Student',
    column_type: 'string',
    column_name: 'height',
  },
  weight_gteq: {
    model_name: 'Student',
    column_type: 'string',
    column_name: 'weight',
  },
  weight_lteq: {
    model_name: 'Student',
    column_type: 'string',
    column_name: 'weight',
  },
  course_times_gteq: {
    model_name: 'Student',
    column_type: 'string',
    column_name: 'courseTimes',
  },
  course_times_lteq: {
    model_name: 'Student',
    column_type: 'string',
    column_name: 'courseTimes',
  },
  courses_count_gteq: {
    model_name: 'Student',
    column_type: 'string',
    column_name: 'coursesCount',
  },
  courses_count_lteq: {
    model_name: 'Student',
    column_type: 'string',
    column_name: 'coursesCount',
  },
}
export const formColumnsConfig = {
  'self': {
    'name': { required: true, disabledUpdate: false },
    'phone': { required: true, disabledUpdate: false },
    'book_club_course_numbers': { required: false, disabledUpdate: false },
    'city': { required: false, disabledUpdate: false },
    'course_stickiness': { required: false, disabledUpdate: false },
    'course_times': { required: false, disabledUpdate: false },
    'courses_count': { required: false, disabledUpdate: false },
    'height': { required: false, disabledUpdate: false },
    'nps_list': { required: false, disabledUpdate: false },
    'nps_source': { required: false, disabledUpdate: false },
    'nps_value': { required: false, disabledUpdate: false },
    'occupation': { required: false, disabledUpdate: false },
    'weight': { required: false, disabledUpdate: false },
    'youth_camp_course_numbers': { required: false, disabledUpdate: false },
    'gender': { required: false, disabledUpdate: false },
    'user_id': { required: false, disabledUpdate: false },
    'bridge': { required: false, disabledUpdate: false },
    'holder': { required: false, disabledUpdate: false },
    'partner': { required: false, disabledUpdate: false },
    'potential': { required: false, disabledUpdate: false },
    'student': { required: false, disabledUpdate: false },
    'remark': { required: false, disabledUpdate: false },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns, { filterColumnsExtend } = {}) => {
  return entityColumnsExtend(shareColumnsExtend('Student', columns), { filterColumnsExtend })
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('Student', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
